import {Outlet} from "react-router-dom";
import {useInit} from "@follosoft/react-components";
import {LanguageSelector} from "@/components/LanguageSelector.tsx";
import {getAccountLogo} from "@/utils/account-logo";

export default function AuthLayout() {
  const { account } = useInit();

  return (
    <div className="relative flex flex-col h-screen bg-white max-w-3xl mx-auto shadow-lg p-10">
      <nav className="flex justify-between items-center gap-7 h-10">
        <img alt="logo" data-testid="logo" className="max-h-full h-full" src={getAccountLogo(account)}/>
        <div className="flex-1 flex justify-end">
          <LanguageSelector/>
        </div>
      </nav>
      <Outlet/>
    </div>
  );
}
